import qs from 'qs';
import { config } from './consts';

export const debounceEmail = async (email: string) => {
    const response = await fetch(
        `https://api.debounce.io/v1/?${qs.stringify({ email, api: config.debounceKey })}`,
        {
            method: 'GET',
            headers: { accept: 'application/json' }
        }
    );

    const parsedRes = await response.json();

    return { [response.ok ? 'res' : 'err']: parsedRes };
};
